import React from 'react';
import { styled } from '@compiled/react';
import { SkeletonItem, MenuGroup } from '@atlaskit/menu';
import { Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import { CONTENT_MIN_WIDTH } from '../../../common/constants.tsx';

export const LoadingSkeleton = () => (
	<Box xcss={wrapperStyles}>
		<Box xcss={skeletonWrapperStyles}>
			<Box xcss={listSkeletonWrapperStyles}>
				<MenuGroup minWidth={280}>
					<Box xcss={titleSkeletonWrapperStyles}>
						<Skeleton />
					</Box>
					<SkeletonItem hasIcon />
					<SkeletonItem hasIcon />
					<SkeletonItem hasIcon />
					<Box xcss={titleSkeletonWrapperStyles}>
						<Skeleton />
					</Box>
					<SkeletonItem hasIcon />
					<SkeletonItem hasIcon />
					<SkeletonItem hasIcon />
				</MenuGroup>
			</Box>
			<Box xcss={detailsSkeletonWrapperStyles}>
				<SkeletonPreview />
				<Skeleton />
				<Skeleton />
				<SkeletonButton />
			</Box>
		</Box>
	</Box>
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Skeleton = styled.div({
	backgroundColor: token('color.skeleton'),
	borderRadius: token('space.050'),
	width: '180px',
	height: token('space.200'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const SkeletonPreview = styled(Skeleton)({
	width: '240px',
	height: '132px',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const SkeletonButton = styled(Skeleton)({
	width: '84px',
	height: token('space.400'),
});

const skeletonWrapperStyles = xcss({
	height: '100%',
	display: 'flex',
	flexDirection: 'row',
});

const titleSkeletonWrapperStyles = xcss({
	height: '42px',
	width: '100%',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'flex-start',
	paddingInlineStart: 'space.250',
});

const listSkeletonWrapperStyles = xcss({
	paddingBlockStart: 'space.100',
	blockSize: '100%',
	inlineSize: '280px',
});

const detailsSkeletonWrapperStyles = xcss({
	alignItems: 'start',
	backgroundColor: 'elevation.surface.sunken',
	blockSize: '100%',
	borderColor: 'color.border',
	borderStyle: 'solid',
	borderWidth: 'border.width.0',
	borderInlineStartWidth: 'border.width',
	boxSizing: 'border-box',
	display: 'flex',
	flexDirection: 'column',
	gap: 'space.200',
	inlineSize: '320px',
	justifyContent: 'start',
	padding: 'space.500',
});

const wrapperStyles = xcss({
	boxSizing: 'border-box',
	color: 'color.text',
	blockSize: '385px',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	inlineSize: `${CONTENT_MIN_WIDTH}px`,
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
});
